import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Typography,
} from "../material-old";
import { Button as AntButton, message, Table as AntTable } from "antd";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../redux/hooks.ts";
import { useNavigate } from "react-router-dom";
import { fetchAllTemplates } from "../../redux/actions/templatesActions.tsx";
import { generateTagColors } from "../../utils/common/generateTagColors.ts";
import { CoreLoading } from "../common/CoreLoading.tsx";
import { Template } from "../../redux/interfaces/templates.types.ts";
import { extractErrorMessage } from "../../utils/extractErrorMessage.ts";
import { TEMPLATES_TABLE_HEAD } from "./fixtures/templatesTable.tsx";

export const TableComponent = () => {
  const [page, setPage] = useState(1);
  const { text: search } = useAppSelector((state) => state.search);
  const [tagColors, setTagColors] = useState({});

  const limit = 5;
  const {
    results: templates,
    next,
    previous,
    count,
    loading,
  } = useAppSelector((state) => state.templates);
  const [dataSource, setDataSource] = useState<any[]>([]);

  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [messageApi, contextHolder] = message.useMessage();

  const totalPages = Math.ceil(count / limit);

  useEffect(() => {
    fetchInitialTemplates();
  }, []);

  useEffect(() => {
    onFilterTemplates();
  }, [search]);

  useEffect(() => {
    onUpdateSource();
  }, [templates]);

  const onFilterTemplates = () => {
    if (!search) {
      onUpdateDataSource(tagColors, templates);
      return;
    }

    const filtered = templates.filter((template) =>
      template.name.toLowerCase().includes(search.toLowerCase()),
    );
    onUpdateDataSource(tagColors, filtered);
  };

  const onUpdateDataSource = (
    tags: { [key: string]: string },
    templates: Template[],
  ) => {
    const data = templates.map((temp) => ({
      ...temp,
      key: temp.id,
      color: tags[`${temp.base_requirements.length}`],
      onClick: () => navigate(`/templates/${temp.id}`),
    }));
    setDataSource(data);
  };

  const onUpdateSource = () => {
    if (!templates.length) return;

    const tags = generateTagColors(
      templates.map((temp) => `${temp.base_requirements.length}`),
    );
    setTagColors(tags);

    onUpdateDataSource(tags, templates);
  };

  const fetchInitialTemplates = async () => {
    if (loading) return;

    try {
      await dispatch(
        fetchAllTemplates(`/docvault/templates/?limit=${limit}`),
      ).unwrap();
    } catch (error: any) {
      messageApi.error(extractErrorMessage(error, "No se pudieron cargar las plantillas."));
    }
  };

  const onFetchPrevious = async () => {
    const temps = await dispatch(fetchAllTemplates(previous!)).unwrap();
    setPage(page - 1);

    onUpdateDataSource(tagColors, temps.results);
  };

  const onFetchNext = async () => {
    const temps = await dispatch(fetchAllTemplates(next!)).unwrap();
    setPage(page + 1);

    onUpdateDataSource(tagColors, temps.results);
  };

  if (loading) {
    return (
      <Card className="w-full p-8">
        <CoreLoading size={1} />
      </Card>
    );
  }

  return (
    <Card className="w-full p-8">
      {contextHolder}
      <CardHeader floated={false} shadow={false} className="rounded-none">
        <Typography variant="h5" color="blue-gray" className="mb-2">
          Plantillas
        </Typography>
      </CardHeader>
      <CardBody className="overflow-scroll px-0">
        <AntTable
          columns={TEMPLATES_TABLE_HEAD}
          dataSource={dataSource}
          pagination={false}
        />
      </CardBody>
      <CardFooter className="flex items-center justify-between border-t border-blue-gray-50 p-4">
        <Typography variant="small" color="blue-gray" className="font-normal">
          Página {page} de {totalPages}
        </Typography>
        <div className="flex gap-2">
          {!!previous && (
            <AntButton
              type="dashed"
              className="flex items-center gap-3"
              onClick={onFetchPrevious}
            >
              Anterior
            </AntButton>
          )}
          {!!next && (
            <AntButton
              type="primary"
              className="flex items-center gap-3"
              onClick={onFetchNext}
            >
              Siguiente
            </AntButton>
          )}
        </div>
      </CardFooter>
    </Card>
  );
};
